<a class="sortBy" [ngClass]="{selected: selected, sortAsc: selected && sortDir === 'asc', sortDesc: selected && sortDir === 'desc'}" (click)="onSort()">
	<ng-content></ng-content>
	<i *ngIf="selected && sortDir === 'asc'" class="fa fa-caret-up"></i>
	<i *ngIf="selected && sortDir === 'desc'" class="fa fa-caret-down"></i>
	<i *ngIf="!selected" class="fa fa-sort"></i>
</a>